import { Col, Form, Input, Select } from "antd";
import CustomDatePicker from "common/CustomDatePicker";
import { useEffect, useState } from "react";
import { getData } from "../../../apiServices/common";

const ImportVehicleInfoFilterFields = ({ initialTableData }) => {
  const { Option } = Select;
  const [b2bLcList, setB2bLcList] = useState([]);

  useEffect(() => {
    getB2BLcList();
  }, []);

  const getB2BLcList = async () => {
    let get_b2blc_list = `/api/accounting/b2blcs-for-noting`;
    let res = await getData(get_b2blc_list);

    if (res) {
      setB2bLcList(res?.data?.data || []);
    }
  };

  const typeOfShipmentOptions = [
    { value: "LC", label: "LC" },
    { value: "RTGS", label: "RTGS" },
    { value: "FOC", label: "FOC" },
    { value: "TT", label: "TT" },
  ];

  return (
    <>
      <Col span={4}>
        <Form.Item label="Type Of Shipment" name="type_of_shipment">
          <Select placeholder="Select Type of Shipment" size="small" allowClear>
            {typeOfShipmentOptions.map((option) => (
              <Option value={option.value} key={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Invoice Number" name="invoice_number">
          <Input placeholder="Enter Invoice Number" size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="B2BLC No" name="b2b_lc_number">
          <Select
            showSearch
            placeholder="Select B2BLC No"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            size="small"
            allowClear
          >
            {b2bLcList?.length &&
              b2bLcList.map((sup) => (
                <Option value={sup.b2b_lc_number} key={sup.id}>
                  {sup.b2b_lc_number}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="From Date" name="from_date">
          <CustomDatePicker
            placeholder="From Date"
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="To Date" name="to_date">
          <CustomDatePicker
            placeholder="To Date"
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default ImportVehicleInfoFilterFields;
